export default __webpack_public_path__ + "arrow_right.56252f90.svg";